import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import Field from "../../Shared/Wizard/Field/Field";
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from "react-polyglot";
import { useHistory } from "react-router-dom";
import './LostPasword.scss';

function LostPassword(){
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();
    const history = useHistory();
    
    
    const [inputEmail, setInputEmail] = useState("");
    const [sendtEmail, setSendtEmail] = useState("");
    const [sendt, setSendt] = useState(false);
    const [invalid, setInvalid] = useState(false);
    
    function handleSendRequest(evt){
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        // let pattern = new RegExp(/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,})+)$/);
        let pattern = new RegExp(/^([\w\.\-\å\ø\æ]+)@([\w\-\å\ø\æ]+)((\.(\w){2,})+)$/);
        if (!pattern.test(inputEmail)) {
            setInvalid(true);
            setSendt(false);
        }
        else{
            setInvalid(false);
            setSendtEmail(inputEmail);
            setSendt(false);
            
            axios.all([
                axios.single({
                    method: "post",
                    url: "/api/users/forgot-password",
                    responseType: "json",
                    data: { email: inputEmail }
                })
            ])
            .then(axios.spread((...res) => {
                setSendt(true);
            }))
            .catch(err => console.log(err));
        }
    }
    
    function toLogin(evt){
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        history.push("/");
        
    }
    
    return (
        <div className="logincontainer">
            <div className="row justify-content-center">
                <div className="col-lg-5">
                    <Card>
                        <div className="card-header pt-4 pb-4 text-center login-header">
                            <a href="/">
                                <span><img src={"https://via.placeholder.com/120x120"} alt="" width="200" /></span>
                            </a>
                        </div>
                        <Card.Body>
                            <div className="welcometext">
                                <h4>{t("password.reset.lost_title")}</h4>
                                <p>{t("password.reset.lost_description")}</p>
                            </div>
                            <div className="loginform">
                                <div>
                                    <Field type="input" value={inputEmail} onChange={setInputEmail}/>
                                </div>
                                <div className="buttonbox">
                                    <Button onClick={handleSendRequest}> {t("password.reset.send_mail")} </Button>
                                </div>
                                {sendt ? (
                                    <div className="confirmText">
                                        {t("password.reset.lost_sendt_head")} "{sendtEmail}".
                                        <div className="confirmSubtext">
                                            {t("password.reset.lost_sendt_body")}
                                        </div>
                                    </div>
                                ) : ""}
                                {invalid ? (
                                    <div>
                                        {t("password.reset.invalid_email")}
                                    </div>
                                ) : ""}
                                <div className="buttonbox">
                                    <Button onClick={toLogin}> {t("password.reset.back")} </Button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
    
}


export default LostPassword;